import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {CollaborationConfig} from './collaboration.config';

@Injectable()
export class CollaborationApiService {

  constructor(private httpClient: HttpClient) {
  }

  getCollaborationAvatar(email: string, name: string, avatarSize: number ): Observable<string> {
    const url = CollaborationConfig.getCollaborationAvatarApi(email, name, avatarSize);
    return this.httpClient.get<string>(url);
  }

}


